import { createContext, useContext } from "react";
import { stdObject } from "../data/types/stdObject";

export const StructureContext = createContext<stdObject>({});

export const useStructureContext = () => useContext(StructureContext);
